import { useState, useEffect } from "react";
import type { Page, Sequence, Contact } from "./types";
import { sequences as initialSequences, contacts as initialContacts } from "./data";

let globalPage: Page = "dashboard";
let globalSelectedSequenceId: string | null = null;
let globalSelectedContactId: string | null = null;
let globalSequences = [...initialSequences];
let globalContacts = [...initialContacts];
let listeners: Set<() => void> = new Set();

function notify() {
	listeners.forEach((l) => l());
}

export function useAppStore() {
	const [, setTick] = useState(0);

	useEffect(() => {
		const listener = () => setTick((t) => t + 1);
		listeners.add(listener);
		return () => {
			listeners.delete(listener);
		};
	}, []);

	return {
		page: globalPage,
		selectedSequenceId: globalSelectedSequenceId,
		selectedContactId: globalSelectedContactId,
		sequences: globalSequences,
		contacts: globalContacts,

		navigate(page: Page, sequenceId?: string, contactId?: string) {
			globalPage = page;
			globalSelectedSequenceId = sequenceId ?? null;
			globalSelectedContactId = contactId ?? null;
			notify();
		},

		updateSequence(id: string, updates: Partial<Sequence>) {
			globalSequences = globalSequences.map((s) => (s.id === id ? { ...s, ...updates } : s));
			notify();
		},

		updateContact(id: string, updates: Partial<Contact>) {
			globalContacts = globalContacts.map((c) => (c.id === id ? { ...c, ...updates } : c));
			notify();
		},
	};
}
